import React, { useState } from 'react'
import { Button } from 'antd'
import { useFlags } from 'launchdarkly-react-client-sdk'
import NewMessageContainer from '.'
import MessageTemplateSelectionModal from '../CommentTemplateDropdown/MessageTemplateSelectionModal'
import { connect, useSelector } from 'react-redux'
import { selectAllOrderData } from '@app/store/reducers/order/orderSelectors'
import { compose } from 'redux'
import { connectResource } from '@app/common/utils/resource'
import { selectLenderId } from '@app/store/reducers/user/userSelectors'
import CommentTemplateDropdown from '../CommentTemplateDropdown'
import { checkPermission } from '@app/common/utils/helpers'

const ChatSelector = (props) => {
  const [inputMode, setInputMode] = useState(null) // null, 'chat'
  const [templateModalVisible, setTemplateModalVisible] = useState(false)
  const orderData = useSelector(selectAllOrderData)

  const flags = useFlags() || {}

  const onSelectTemplate = () => {
    setTemplateModalVisible(true)
  }

  const onWriteCustomMessage = () => {
    setInputMode('chat')
  }

  const onTemplateSelect = (templatedText, template) => {
    setInputMode('chat')
    props.setTextToInsert(templatedText)
    props.setSelectedTemplate(template)
  }

  const onCancelTemplateModal = () => {
    setTemplateModalVisible(false)
  }

  const isTemplateVisible = checkPermission('view_message_templates') && flags?.useUpdatedMessageTemplatesUx && props.allowMessageParticipation &&
    props.shouldGetMessages &&
    props.primaryConversationType &&
    props.primaryConversation &&
    !orderData.has_been_reassigned

  if (!isTemplateVisible) {
    return <NewMessageContainer {...props} />
  }

  const isUnifiedConversation = props.primaryConversationType === 'unified_conversation'

  if (!flags?.useTemplateFirstInput || inputMode === 'chat' || checkPermission('approve_conversation_messages') || !isUnifiedConversation) {
    return <>
      {isTemplateVisible && (
        <CommentTemplateDropdown
          name={'order-messages-templates-list'}
          onHide={props.onHide}
          refreshOrder={props.refreshOrder}
          setTextToInsert={props.setTextToInsert}
          setSelectedTemplate={props.setSelectedTemplate}
          audienceFilter={props.audienceFilter}
        />
      )}
      <NewMessageContainer {...props} onViewAllTemplates={onSelectTemplate}
        isTemplateSuggestionEnabled={props.isTemplateSuggestionEnabled} />
      <MessageTemplateSelectionModal
        visible={templateModalVisible}
        onCancel={onCancelTemplateModal}
        templates={props.templates?.data?.templates || []}
        onTemplateSelect={onTemplateSelect}
        orderData={orderData}
        audienceFilter={props.audienceFilter}
      />
    </>
  }
  // Only show the Template First buttons if this is a UnifiedConversation
  if (isTemplateVisible && !inputMode && isUnifiedConversation) {
    return (
      <>
        <div className="w-100 d-flex align-items-center">
          <div className="d-flex gap-2 w-100">
            <Button
              type="primary"
              onClick={onSelectTemplate}
              className="w-100 mr-2"
            >
            Select Pre-Approved Template
            </Button>
            <Button
              onClick={onWriteCustomMessage}
              className="w-100"
            >
            Write Custom Message
            </Button>
          </div>
        </div>
        <MessageTemplateSelectionModal
          visible={templateModalVisible}
          onCancel={onCancelTemplateModal}
          templates={props.templates?.data?.templates || []}
          onTemplateSelect={onTemplateSelect}
          orderData={orderData}
          audienceFilter={props.audienceFilter}
        />
      </>
    )
  }
}

const mapStateToProps = state => ({
  lenderId: selectLenderId(state),
})

// Wrapper component to handle feature flag
const ChatSelectorWrapper = (props) => {
  const flags = useFlags() || {}
  const useSecureEndpoint = flags?.plat2773UseSecureMessageTemplateEndpoint || false

  // Dynamically create the connected component based on the flag
  const ConnectedComponent = React.useMemo(() => {
    return compose(
      connect(mapStateToProps),
      connectResource({
        namespace: 'templates',
        endpoint: useSecureEndpoint
          ? 'lender/messageTemplates'
          : 'lender/messageTemplate/:lenderId',
        prefetch: false,
        apiVersion: 2,
      })
    )(ChatSelector)
  }, [useSecureEndpoint])

  return <ConnectedComponent {...props} />
}

export default ChatSelectorWrapper
